import script from "./WorldPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldPage.vue?vue&type=script&setup=true&lang=js"

import "./WorldPage.vue?vue&type=style&index=0&id=d87d1e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87d1e44"]])

export default __exports__